import { fetchPDVInMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const PDVInMarketResearchKeys = {
    all: ['pdvinmarketresearch'] as const,
    lists: () => [...PDVInMarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...PDVInMarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...PDVInMarketResearchKeys.all, 'detail'] as const,
    detail: (params: number) => [...PDVInMarketResearchKeys.details(), params] as const,
}

export const usePDVInMarketResearchQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchPDVInMarketResearch(SK_PESQUISA),
        queryKey: PDVInMarketResearchKeys.detail(SK_PESQUISA),
    })
}
